import { render, staticRenderFns } from "./ViewOld.vue?vue&type=template&id=47ca5efc&scoped=true&"
import script from "./ViewOld.vue?vue&type=script&lang=js&"
export * from "./ViewOld.vue?vue&type=script&lang=js&"
import style0 from "./ViewOld.vue?vue&type=style&index=0&id=47ca5efc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ca5efc",
  null
  
)

export default component.exports